import {useDispatch, useSelector} from "@/store";
import {getState, reset, togglePinned, toggleWithSub} from "@/store/extensionsPageActions.ts";
import {Card, CardContent} from "@/components/ui/card.tsx";
import {Square2StackIcon, XMarkIcon} from "@heroicons/react/24/outline";
import {ArrowRightLeftIcon, PinIcon, PinOffIcon} from "lucide-react";
import {cn} from "@/lib/utils.ts";

export function GlobalActionsTool() {

    const {action, withSub, pinned: isPinned, extension} = useSelector(getState);
    const dispatch = useDispatch();

    if(!action && !extension) {
        return null;
    }

    const label = action ? {
        'duplicate': 'שכפול שלוחה',
        'moving': 'העברת שלוחה',
        'copy_settings': 'ההגדרות הועתקו ללוח',
    }[action] ?? null : null;

    return (
        <div className="fixed bottom-10 end-10">
            <button
                className="absolute -top-1 end-0 cursor-pointer rounded-full size-5 bg-light-blue-50 hover:bg-light-blue-100 flex items-center justify-center"
                onClick={() => dispatch(reset())}
            >
                <XMarkIcon className="size-3 text-light-blue-800"/>
            </button>
            <Card className="rounded-full bg-light-blue-500/10 border border-blue-600/30">
                <CardContent className="flex gap-2 items-center !px-4 !pe-6 !py-2 ">
                    {action === 'duplicate' && (
                        <button
                            onClick={() => dispatch(toggleWithSub())}
                            className={cn("group/button cursor-pointer transition-colors h-8 px-4 text-xs flex items-center justify-center rounded-full bg-light-blue-50 text-light-blue-800", {
                                'bg-light-blue-600/20': withSub,
                            })}>
                            {withSub ? 'ללא תתי שלוחות' : 'כלול תתי שלוחות'}
                        </button>

                    )}
                    {action !== 'duplicate' && <button
                        onClick={() => dispatch(togglePinned())}
                        className="group/button cursor-pointer size-8 flex items-center justify-center rounded-full bg-light-blue-50 text-light-blue-800">
                        {action === 'copy_settings' && (isPinned
                                ? <>
                                    <PinIcon className="group-hover/button:hidden size-5"/>
                                    <PinOffIcon className="group-hover/button:block hidden size-5"/>
                                </>
                                : <>
                                    <Square2StackIcon className="group-hover/button:hidden size-6"/>
                                    <PinIcon className="group-hover/button:block hidden  size-5"/>
                                </>
                        )}
                        {action === 'moving' && <ArrowRightLeftIcon className="size-6"/>}
                    </button>}

                    <div>
                        <div className="text-sm">שלוחה {extension?.name} ({extension?.path ?? 'ראשי'})</div>
                        <div className="text-xs text-gray-500">{label}</div>
                    </div>
                </CardContent>
            </Card>
        </div>

    )
}